import { render, staticRenderFns } from "./EMelderComponentMeldenBs1AnzeigeText.vue?vue&type=template&id=3d86be1a"
import script from "./EMelderComponentMeldenBs1AnzeigeText.vue?vue&type=script&lang=js"
export * from "./EMelderComponentMeldenBs1AnzeigeText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports